import { render, staticRenderFns } from "./forgetPass.vue?vue&type=template&id=209ee2e7&"
import script from "./forgetPass.vue?vue&type=script&lang=js&"
export * from "./forgetPass.vue?vue&type=script&lang=js&"
import style0 from "./forgetPass.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports